<template>
  <v-card class="custom-card" :class="!isComponent ? 'not-component' : ''">
    <v-row>
      <v-col>
        <v-row v-if="!tiroCerteiro">
          <v-col>
            <div class="gray-label default-height">
              Não existe nenhuma competição a decorrer
            </div>
          </v-col>
        </v-row>
        <v-row class="competition-row" v-else>
          <v-col>
            <div class="green-label">Competição</div>

            <div class="gray-label" style="margin-top: 24px">Prémio</div>
            <div class="big-black-value" style="margin-top: 8px">
              {{ tiroCerteiro.prize }}
            </div>
            <div class="dark-gray-label" style="margin-top: 8px">
              {{ tiroCerteiro.description }}
            </div>
            <v-row style="margin-top: 30px">
              <v-col cols="11" style="padding: 0 12px">
                <div>
                  <span class="gray-label">Data limite: </span>
                  <span class="gray-label" style="text-transform: capitalize">{{
                    $moment(tiroCerteiro.endDate, "x").format("D MMM YYYY")
                  }}</span>
                </div>
                <CustomProgressBar
                  :percentage="getPercentage()"
                ></CustomProgressBar>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <div class="gray-label">Classificação</div>
            <v-card
              class="ranking-card"
              v-for="(item, index) in ranking"
              :key="'ranking-' + index"
            >
              <v-list-item v-if="$lodash.isEmpty(item)"> </v-list-item>
              <v-list-item v-else>
                <v-list-item-avatar class="ranking-avatar" size="32">
                  <v-img :src="avatar(item.user.photo)"></v-img>
                </v-list-item-avatar>
                <v-badge
                  overlap
                  :content="index + 1"
                  offset-x="30"
                  offset-y="-4"
                ></v-badge>
                <v-list-item-content>
                  <v-list-item-title class="ranking-title">{{
                    item.user.name
                  }}</v-list-item-title>
                  <v-list-item-subtitle class="user-subtitle">
                    {{ parseFloat(item.points).toFixed(2) }}
                    Pontos</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col class="floating-button">
            <v-row :class="!isComponent ? 'align-center justify-center' : ''">
              <v-col class="large-btn">
                <v-btn
                  block
                  large
                  depressed
                  :color="isPremium() ? 'primary' : '#D8E0E6'"
                  :class="isPremium() ? '' : 'gray-button'"
                  :to="isPremium() ? '/tiro-certeiro/prognosticos' : ''"
                  >Jogar</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.default-height {
  height: 296px;
  text-align: center;
  vertical-align: middle;
  line-height: 296px !important;
}
.not-component .default-height {
  height: 618px;
  text-align: center;
  vertical-align: middle;
  line-height: 618px !important;
}
.custom-card.v-card {
  padding: 0 24px !important;
}
.green-label {
  font-size: 11px;
  line-height: 16px;
  padding-bottom: 0;
  font-family: Gilroy-Bold;
  color: #26ab5e;
  padding-right: 4px;
  vertical-align: top;
}
.gray-label {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc;
}
.dark-gray-label {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 16px;
  color: #6d818f;
}
.black-value {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #304351;
}
.big-black-value {
  font-family: Gilroy-SemiBold;
  font-size: 24px;
  line-height: 28px;
  color: #304351;
}
.v-list-item {
  height: 48px;
}
.v-list-item__content {
  padding: 8px 0;
}
.ranking-card {
  margin-top: 8px;
  box-shadow: 0px 0px 8px rgba(48, 67, 81, 0.08) !important;
  max-height: 48px;
}
.ranking-avatar {
  border: 2px solid #26ab5e;
}
.v-badge__badge {
  background-color: #26ab5e;
}
.ranking-card:nth-of-type(2) .ranking-avatar,
.ranking-card:nth-of-type(2) >>> .v-badge__badge {
  border-color: #ffc121;
  background-color: #ffc121 !important;
}
.ranking-card:nth-of-type(3) .ranking-avatar,
.ranking-card:nth-of-type(3) >>> .v-badge__badge {
  border-color: #bcc5cc;
  background-color: #bcc5cc !important;
}
.ranking-card:nth-of-type(4) .ranking-avatar,
.ranking-card:nth-of-type(4) >>> .v-badge__badge {
  border-color: #ab8626;
  background-color: #ab8626 !important;
}
.ranking-title {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 16px;
  color: #304351 !important;
}
.ranking-subtitle {
  font-family: Gilroy-Bold;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: capitalize;
  color: #bcc5cc !important;
}
.floating-button {
  width: 100%;
  position: absolute;
  bottom: 0;
  width: 180px;
}
.competition-row > .col {
  flex: 0 0 50%;
  max-width: 50%;
}
.not-component .competition-row > .col {
  flex: 0 0 100%;
  max-width: 100%;
}
.not-component .floating-button {
  width: 100%;
  position: relative;
  padding: 0 12px;
}
@media only screen and (min-width: 1024px) {
  /* .not-component.custom-card {
    height: 688px;
  } */
}
@media only screen and (max-width: 1024px) {
  .not-component .floating-button {
    margin-top: 0;
  }
  .dashboard-height,
  .not-component .default-height {
    height: 200px;
    text-align: center;
    vertical-align: middle;
    line-height: 200px !important;
  }
}
@media only screen and (max-width: 480px) {
  .floating-button {
    position: relative;
  }
  .competition-row .col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>

<script>
import Vue from "vue";
import CustomProgressBar from "@/components/CustomProgressBar.vue";

import DateTimeService from "@/services/datetime.service";

export default Vue.extend({
  name: "PrognosticoCard",
  components: {
    CustomProgressBar,
  },
  props: {
    isComponent: Boolean,
    tiroCerteiro: {},
    ranking: Array,
  },
  data: () => ({
  }),
  methods: {
    getLogo(image) {
      const logo = image ? image : "avatar.png";
      //return require("../assets/images/" + logo);
    },
    getPercentage() {
      return DateTimeService.getPercentage(
        this.$moment(this.tiroCerteiro.startDate, "x"),
        this.$moment(this.tiroCerteiro.endDate, "x")
      );
    },
    isTiroCerteiro() {
      return this.$route.path.includes("tiro-certeiro");
    },
    isPremium() {
      return this.$store.state.premium;
    },
    avatar(photo) {
      if (photo) {
        return photo;
      } else {
        return require("../assets/images/avatar.png");
      }
    },
  },
  computed: {},
});
</script>
